import './App.css';
import QRCodeGenerator from './QRCodeGenerator';

function App() {
  return (
    <div>
      <QRCodeGenerator />
    </div>
  );
}

export default App;
